import React from "react";
import * as Yup from "yup";
import { AiOutlineClose } from "react-icons/ai";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import "./onboarding.css";
import { createPassword } from "../../actions/auth.action";
import ErrorInputComponent from "../../components/ErrorInputComponent";
import DocButtomButton from "../../components/DocButtomButton";
import { Loading } from "../../utils/helpers/constants";

export default function CreateNewPassword() {
  const history = useHistory();
  const dispatch = useDispatch();

  const {
    auth: { createPasswordLoading },
  } = useSelector(({ authReducer }) => ({ auth: authReducer }));

  const validationSchema = Yup.object({
    otp: Yup.string()
      .required("Activation code is required")
      .min(5, "Minimum of 5 digits are required"),
    password: Yup.string()
      .required("Please Enter your password")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
      ),
    confirmPassword: Yup.string()
      .required("Confirm password is required")
      .oneOf([Yup.ref("password"), null], "Passwords must match"),
  });
  const { handleSubmit, handleChange, errors } = useFormik({
    initialValues: {
      otp: "",
      password: "",
      confirmPassword: "",
    },
    validationSchema,
    onSubmit(values) {
      const navigateLink = () => history.push("/login");
      dispatch(createPassword(values.password, values.otp, navigateLink));
    },
  });

  const loadState = createPasswordLoading === Loading.FETCHING;

  return (
    <div className="flex flex-column justify-center">
      <div className="App-height p-5 md:w-1/3">
        <div>
          <AiOutlineClose
            size={25}
            className="mt-5"
            onClick={() => history.goBack()}
          />
          <h1 className="a_acc_header mt-5">Create Password</h1>
          <p className="a_acc_header_text">
            Add your password to secure your account every time you need to
            login again.
          </p>
        </div>
        <form className="mt-10" onSubmit={handleSubmit}>
          <input
            className="appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
            id="inline-full-name"
            type="text"
            name="otp"
            onChange={handleChange}
            placeholder="Activation Code"
          />
          <ErrorInputComponent error={errors.otp} />
          <input
            className="mt-3 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
            id="inline-full-name"
            type="password"
            name="password"
            onChange={handleChange}
            placeholder="Password"
          />
          <ErrorInputComponent error={errors.password} />
          <input
            className="mt-3 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
            id="inline-full-name"
            type="password"
            name="confirmPassword"
            onChange={handleChange}
            placeholder="Confirm Password"
          />
          <ErrorInputComponent error={errors.confirmPassword} />
        </form>
        <DocButtomButton
          loading={loadState}
          name={"Next"}
          func={() => handleSubmit()}
        />
      </div>
    </div>
  );
}
